import Field from './Field';
import ReactStrapComponent from './ReactStrapComponent';

const TextField = (props) => (
  <Field type="text" component={ReactStrapComponent} {...props} />
);

export default TextField;
